import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { ImportantNote } from "@/components/ui/importantNote";

type QuoteProvideContactProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  handleCreateQuote: (isDraft: boolean) => void;
  isPendingCreateQuote: boolean;
};
export default function ConfirmCreateQuote({
  isOpen,
  setIsOpen,
  handleCreateQuote,
  isPendingCreateQuote,
}: QuoteProvideContactProps) {
  return (
    <Dialog open={isOpen} onOpenChange={() => setIsOpen(false)}>
      <DialogTitle className="hidden">Confirm Quote creation</DialogTitle>
      <DialogDescription className="hidden">
        Review and accept the terms of service before creating your quote
      </DialogDescription>
      <DialogContent>
        <div className="md md:max-h-auto flex max-h-[380px]  flex-col overflow-auto">
          <ImportantNote>
            By clicking confirm below, I agree to Stryker Industrial Solutions, LLC’s terms of service, and I certify
            the information I provided in connection with this form is true and correct to the best of my knowledge. I
            also understand that any false information or deliberate omissions on this form may subject me to immediate
            termination of all services provided to me by Stryker Industrial Solutions, LLC.
          </ImportantNote>
          <Button onClick={() => handleCreateQuote(false)} className="mt-4 self-center" disabled={isPendingCreateQuote}>
            Confirm
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
